<template>
	<div style="width: auto; margin: 0;">
		<label
			style="display: inline-block; padding: 5px; height: auto; font-size: 18px; color: var(--text_color)"
			:for="check_id"
		>
			<slot/>
		</label>
		<input
			type="checkbox" style="display: inline-block;"
			v-model="rule_value"
			:id="check_id"
			@change="change_house_rule(rule, rule_value)"
		>
	</div>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
	props: {
		rule: String
	},
	// this is more convoluted than just checking the value because
	// that leads to console errors when the game state has changed
	// but this view is still active due to lazy loading
	data() {
		return {
			rule_value: this.$store.state.game_data.house_rules[this.rule]
		};
	},
	computed: {
		rule_store() {
			return this.$store.state.game_data.house_rules;
		},
		check_id() {
			return this.rule + "_checkbox";
		}
	},
	watch: {
		rule_store(new_store) {
			if (new_store == undefined) return;
			this.rule_value = new_store[this.rule];
		}
	},
	methods: {
		change_house_rule(rule_name, new_value) {
			var obj = [
				"change_house_rule",
				{
					rule_name, new_value
				}
			];
			console.log("obj", obj);
			this.$store.state.connection.send(JSON.stringify(obj));
		}
	}
})
</script>
